import React, { useState } from 'react'
import { Button, Switch, Table, Typography, Space, Image } from 'antd'
import { profData } from '../../../Data';
import { ActionButton, AlertModal } from '../../../components';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;
const PorfessionalTable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [switchtext, setSwitchText] = useState(false)
    const onChange = () => {
        setSwitchText(true)
        setDeleteItem(true)
    };


    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Professional Name</Text>,
            dataIndex: 'firstName',
            render: (_,row) => `${row?.firstName} ${row?.lastName}`
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Business Name</Text>,
            dataIndex: 'businessname',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Role</Text>,
            dataIndex: 'role',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Rates</Text>,
            dataIndex: 'rate',
            render:(rate) => {
                if(rate === 1){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(rate === 2){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(rate === 3){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(rate === 4){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else{
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                        </Space>
                    )
                }
            }
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>City</Text>,
            dataIndex: 'city',
            width: 200,
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Email</Text>,
            dataIndex: 'email',
            width: 200,
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 'Active') {
                    return <Text className='active fs-12 badge-cs'>Active</Text>;
                } else {
                    return <Text className='inactive fs-12 badge-cs'>Inactive</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Reg Date</Text>,
            dataIndex: 'regDate'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <Switch size='small' defaultChecked onChange={onChange} />
                    <ActionButton
                        title='View Details'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => navigate(`/professional/detail/${row?.id}`)}
                    />
                    <ActionButton
                        title='Delete Client'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.firstName + ' '+ row?.lastName})}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
             <Table
            size='large'
            columns={columns}
            dataSource={profData}
            className='pagination'
            showSorterTooltip={false}
            scroll={{ x: 1600 }}
            pagination={{
                hideOnSinglePage: true,
                total: 12,
                // pageSize: pagination?.pageSize,
                // defaultPageSize: pagination?.pageSize,
                // current: pagination?.pageNo,
                // size: "default",
                // pageSizeOptions: ['10', '20', '50', '100'],
                // onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
            }}
        />
        <AlertModal
          visible={deleteitem}
          deleteitem={deleteitem}
          switchtext={switchtext}
          onClose={()=>{setDeleteItem(false);setSwitchText(null)}}
        />
        </>
    )
}

export { PorfessionalTable }